import { Item, ProductCategoryFilter } from 'types';

export interface CategoryDto {
  name: string;
  displayName: string;
  categoryFilters: ProductCategoryFilter[];
  cost: number | null;
  products: Item[];
  visualizer: boolean;
  slug: string | null;
}

export interface ProductsDto {
  categories: CategoryDto[];

  emptyCategory(): {
    name: string;
    displayName: string;
    products: Item[];
  };
}

const products: ProductsDto = {
  categories: [
    {
      name: 'preconfigured',
      displayName: 'Tuxedos & Suits',
      categoryFilters: [
        { displayName: 'Tux', value: 'Tux' },
        { displayName: 'Suit', value: 'Suit' },
      ],
      cost: 129,
      products: [],
      visualizer: true,
      slug: 'tuxedos-and-suits',
    },
    {
      name: 'Shirt',
      displayName: 'Shirts',
      categoryFilters: [
        { displayName: 'Twill', value: 'Twill' },
        { displayName: 'Pleated', value: 'Pleated' },
      ],
      cost: 20,
      products: [],
      visualizer: true,
      slug: 'shirts',
    },
    {
      name: 'Tie',
      displayName: 'Ties',
      categoryFilters: [
        { displayName: 'Long', value: (str) => !str.includes('Bow') },
        { displayName: 'Bow', value: 'Bow' },
        { displayName: 'Skinny', value: 'Skinny' },
      ],
      cost: 10,
      products: [],
      visualizer: true,
      slug: 'ties',
    },
    {
      name: 'Vest,Cummerbund',
      displayName: 'Vests & Cummerbunds',
      categoryFilters: [
        { displayName: 'Vest', value: 'Vest' },
        { displayName: 'Cummerbund', value: 'Cummerbund' },
      ],
      cost: 10,
      products: [],
      visualizer: true,
      slug: 'vests-and-cummerbunds',
    },
    {
      name: 'Shoe',
      displayName: 'Shoes',
      categoryFilters: [],
      cost: 20,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Pocket Square',
      displayName: 'Pocket Squares',
      categoryFilters: [],
      cost: 10,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Socks',
      displayName: 'Socks',
      categoryFilters: [],
      cost: 10,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Belt,Suspenders',
      displayName: 'Belts & Suspenders',
      categoryFilters: [
        { displayName: 'Belt', value: 'Belt' },
        { displayName: 'Suspenders', value: 'Suspenders' },
      ],
      cost: 10,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Lapel Pin',
      displayName: 'Lapel Pins',
      categoryFilters: [
        { displayName: 'Rose', value: 'Rose' },
        { displayName: 'Carnation', value: 'Carnation' },
      ],
      cost: 10,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Cufflinks',
      displayName: 'Cufflinks',
      categoryFilters: [],
      cost: 25,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Tie Bar',
      displayName: 'Tie Bars',
      categoryFilters: [],
      cost: 25,
      products: [],
      visualizer: true,
      slug: null,
    },
    {
      name: 'Suspenders,Belt,Lapel Pin,Tie Bar,Cufflinks,Pocket Square',
      displayName: 'Accessories',
      categoryFilters: [
        { displayName: 'Tie Bars', value: 'Tie Bar' },
        { displayName: 'Cufflinks', value: 'Cufflinks' },
        { displayName: 'Lapel Pins', value: 'Lapel Pin' },
        { displayName: 'Pocket Squares', value: 'Pocket Square' },
        { displayName: 'Belt', value: 'Belt' },
        { displayName: 'Suspenders', value: 'Suspenders' },
      ],
      cost: null,
      products: [],
      visualizer: false,
      slug: 'accessories',
    },
    {
      name: 'Shoe,Socks',
      displayName: 'Shoes & Socks',
      cost: null,
      categoryFilters: [
        { displayName: 'Shoes', value: 'Shoe' },
        { displayName: 'Socks', value: 'Socks' },
      ],
      products: [],
      visualizer: false,
      slug: 'shoes-and-socks',
    },
  ],

  emptyCategory() {
    return { name: '', displayName: '', products: [] };
  },
};

export default products;
